// React Router counts entries inside the app. Browser history can also contain
// external pages, so history.length alone is not a safe way to go back.
export function goBackInApp(navigate, fallback = '/index') {
  if (window.history.state?.idx > 0) navigate(-1);
  else navigate(fallback, { replace: true });
}

const NOTIFICATION_APP_ORIGIN = 'https://convivial-app.firebaseapp.com';

export function getNotificationDestination(notification) {
  const content = { ...notification?.notification_content, ...notification?.content };
  const key = String(notification?.dedupeKey || '').split(':');
  // Older table notifications did not save groupId, but their receipt key did.
  const legacyGroupId = /^(table-created|table-cancelled|table-left|table-joined|table-new-attendee|table-updated|table-arrival)$/.test(key[0])
    ? key[1] : ['feedback-reminder', 'nearby'].includes(key[0]) ? key[2] : null;
  const groupId = notification?.groupId || content.groupId || notification?.request?.groupId || legacyGroupId;
  if (groupId) return `${NOTIFICATION_APP_ORIGIN}/table/${encodeURIComponent(groupId)}${notification?.type === 'CHAT_MESSAGE' || content.type === 'CHAT_MESSAGE' ? '/chat' : ''}`;
  const candidates = [content.actionUrl, content.link, notification?.actionUrl, notification?.deepLink, notification?.link, notification?.url, notification?.click_action];
  for (const link of candidates) {
    if (typeof link !== 'string' || !link.trim()) continue;
    try {
      const url = new URL(link, window.location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) continue;
      const appHosts = [window.location.host, 'convivial-app.firebaseapp.com', 'convivial-app.web.app', 'convivialapp.it', 'www.convivialapp.it'];
      if (appHosts.includes(url.host)) {
        const basePath = process.env.REACT_APP_BASE_PATH || '';
        const route = basePath && url.pathname.startsWith(`${basePath}/`)
          ? url.pathname.slice(basePath.length) : url.pathname;
        const path = route.replace(/^\/(groups|feedback)\//, '/table/');
        if (path === '/notifications') continue;
        return `${NOTIFICATION_APP_ORIGIN}${path}${url.search}${url.hash}`;
      }
      return url.href;
    } catch {
      // Try the next payload field before falling back to the message details.
    }
  }
  return '';
}

export function getPushNotificationUrl(data = {}) {
  return getNotificationDestination({ ...data, content: { actionUrl: data.actionUrl, link: data.link } })
    || `${NOTIFICATION_APP_ORIGIN}/notifications`;
}

export function openNotificationDestination(navigate, destination) {
  const url = new URL(destination, window.location.origin);
  const appHosts = [window.location.host, 'convivial-app.firebaseapp.com', 'convivial-app.web.app', 'convivialapp.it', 'www.convivialapp.it'];
  if (['http:', 'https:'].includes(url.protocol) && appHosts.includes(url.host)) {
    // Already inside the app: keep its authenticated WebView instead of asking
    // the operating system to open another browser or app instance.
    navigate(`${url.pathname}${url.search}${url.hash}`);
  } else if (['http:', 'https:'].includes(url.protocol)) {
    window.location.assign(url.href);
  }
}
